import { motion } from "framer-motion";
import { useState } from "react";

const links = [
  { href: "#studio", label: "Studio" },
  { href: "#pipeline", label: "Cómo funciona" },
  { href: "#trabajo", label: "Ejemplos" },
  { href: "#precios", label: "Precios" },
];

export function Nav({ onOpenAuth, user, credits }) {
  const [open, setOpen] = useState(false);
  return (
    <motion.header
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 right-0 z-50"
      data-testid="site-nav"
    >
      <div className="mx-auto max-w-[1600px] px-5 md:px-8 pt-4">
        <div className="glass rounded-2xl px-3 md:px-5 py-2.5 flex items-center justify-between">
          <a href="#top" className="flex items-center gap-3" data-testid="brand-logo">
            <span className="relative inline-flex h-6 w-6 rounded-md items-center justify-center bg-[rgb(var(--brand))]/12 border border-[rgb(var(--brand))]/30">
              <span className="absolute inset-0 rounded-md glow-cyan opacity-60" />
              <svg viewBox="0 0 16 16" className="relative w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="1.5" style={{ color: "rgb(var(--brand))" }}>
                <path d="M2 3.5L8 1L14 3.5V12L8 15L2 12V3.5Z" />
                <path d="M8 1V15" />
                <path d="M2 3.5L14 12" />
              </svg>
            </span>
            <span className="font-display text-[15px] md:text-base font-medium text-[rgb(var(--paper))] tracking-tight">
              Nexeron
            </span>
            <span className="font-mono text-[10px] uppercase tracking-[0.24em] text-[rgb(var(--paper-dim))] hidden sm:inline">
              /Studio
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-7 text-[13px] text-[rgb(var(--paper-dim))]">
            {links.map((l, i) => (
              <a
                key={l.href}
                href={l.href}
                className="link-fx hover:text-[rgb(var(--paper))] transition-colors flex items-center gap-1.5"
                data-testid={`nav-${l.label.toLowerCase()}`}
              >
                <span className="font-mono text-[10px] opacity-50">0{i + 1}</span>
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            {user ? (
              <div className="flex items-center gap-1.5 rounded-full border border-white/10 pl-1 pr-1 py-1" data-testid="wallet-chip">
                <a
                  href="#precios"
                  className="hidden sm:inline-flex items-center gap-1.5 rounded-full bg-[rgb(var(--brand))]/10 hover:bg-[rgb(var(--brand))]/20 border border-[rgb(var(--brand))]/20 px-2.5 py-1 transition-colors"
                  data-testid="credits-chip"
                  title="Ver planes de créditos"
                >
                  <span className={`h-1.5 w-1.5 rounded-full ${credits === null ? "bg-red-400" : "bg-[rgb(var(--brand))]"} animate-pulse`} />
                  {credits === null ? (
                    <span className="font-mono text-[10px] uppercase tracking-widest text-red-400" data-testid="credits-error">
                      Error
                    </span>
                  ) : (
                    <>
                      <span className="font-mono text-[11px] text-[rgb(var(--paper))]">
                        {credits.toLocaleString("es-ES")}
                      </span>
                      <span className="font-mono text-[10px] uppercase text-[rgb(var(--paper-dim))]">c</span>
                    </>
                  )}
                </a>
                <button
                  onClick={onOpenAuth}
                  className="rounded-full bg-white/5 hover:bg-white/10 text-[rgb(var(--paper))] px-3 py-1 text-xs font-medium"
                  data-testid="account-btn"
                >
                  {user.email?.split("@")[0] ?? "cuenta"}
                </button>
              </div>
            ) : (
              <button
                onClick={onOpenAuth}
                className="group relative rounded-full text-[rgb(var(--ink))] px-4 md:px-5 py-2 text-xs md:text-sm font-medium overflow-hidden"
                data-testid="open-auth-btn"
              >
                <span className="absolute inset-0 bg-[rgb(var(--brand))] transition-all duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:bg-[rgb(var(--paper))]" />
                <span className="relative flex items-center gap-2">
                  Entrar
                  <span className="inline-block transition-transform group-hover:translate-x-0.5">→</span>
                </span>
              </button>
            )}
            <button
              className="md:hidden rounded-lg glass p-2"
              onClick={() => setOpen((v) => !v)}
              aria-label="menu"
              data-testid="mobile-menu-btn"
            >
              <span className="block w-4 h-[1.5px] bg-[rgb(var(--paper))] mb-1" />
              <span className="block w-4 h-[1.5px] bg-[rgb(var(--paper))]" />
            </button>
          </div>
        </div>

        {open && (
          <div className="md:hidden mt-3 glass rounded-2xl p-5 flex flex-col gap-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-[rgb(var(--paper))] text-sm"
                data-testid={`mnav-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
          </div>
        )}
      </div>
    </motion.header>
  );
}
